import { LogoMark } from '@/shared/components/ui/logo'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

interface IrisShellProps {
  children: ReactNode
  /** The link delivers a form, not an evidence request. */
  isForm?: boolean
}

export function IrisShell({ children, isForm = false }: IrisShellProps) {
  const { t } = useTranslation()
  return (
    <div className="min-h-dvh bg-[var(--bg)] pb-[env(safe-area-inset-bottom)]">
      <div className="mx-auto max-w-lg px-5 pb-12 pt-8">
        <div className="panel-arrive mb-8 flex flex-col items-center gap-3">
          <LogoMark size={20} className="opacity-40" />
          <p className="clara-small text-center tracking-[0.08em] text-[var(--ink-3)]">
            {isForm
              ? t('upload.form.tagline', 'Forms, made simple')
              : 'Evidence submission, made simple'}
          </p>
        </div>
        {children}
      </div>
    </div>
  )
}
